import { ReactNode } from "react"

interface SignUpPassValidationsProps {
    children: ReactNode
}

export function SignUpPassValidations({ children }: SignUpPassValidationsProps) {
    return (
        <div>
            {children}
        </div>
    )
}